import en from "../../locales/en/common.json";
import ar from "../../locales/ar/common.json";
import tr from "../../locales/tr/common.json";
import vi from "../../locales/vi/common.json";
import sw from "../../locales/sw/common.json";
import ha from "../../locales/ha/common.json";
import fr from "../../locales/fr/common.json";
import pt from "../../locales/pt/common.json";
import es from "../../locales/es/common.json";
import so from "../../locales/so/common.json";
import bs from "../../locales/bs/common.json";
import hi from "../../locales/hi/common.json";
import ur from "../../locales/ur/common.json";
import pa from "../../locales/pa/common.json";
import id from "../../locales/id/common.json";
import bn from "../../locales/bn/common.json";
import uz from "../../locales/uz/common.json";
import kk from "../../locales/kk/common.json";
import tg from "../../locales/tg/common.json";
import tk from "../../locales/tk/common.json";
import az from "../../locales/az/common.json";
import ky from "../../locales/ky/common.json";
import am from "../../locales/am/common.json";
import ms from "../../locales/ms/common.json";
import ps from "../../locales/ps/common.json";
import sq from "../../locales/sq/common.json";

export type SupportedLanguage =
  | "en"
  | "ar"
  | "tr"
  | "vi"
  | "sw"
  | "ha"
  | "fr"
  | "pt"
  | "es"
  | "so"
  | "bs"
  | "hi"
  | "ur"
  | "pa"
  | "id"
  | "bn"
  | "uz"
  | "kk"
  | "tg"
  | "tk"
  | "az"
  | "ky"
  | "am"
  | "ms"
  | "ps"
  | "sq";

const locales: Record<SupportedLanguage, Record<string, string>> = {
  en,
  ar,
  tr,
  vi,
  sw,
  ha,
  fr,
  pt,
  es,
  so,
  bs,
  hi,
  ur,
  pa,
  id,
  bn,
  uz,
  kk,
  tg,
  tk,
  az,
  ky,
  am,
  ms,
  ps,
  sq,
};

function isSupportedLanguage(language: string): language is SupportedLanguage {
  return language in locales;
}

export function getStaticT(language?: string) {
  const lang: SupportedLanguage = language && isSupportedLanguage(language) ? language : "en";
  return (key: string) => locales[lang][key] ?? locales.en[key] ?? key;
}
